/**
 * Asynchronously loads the component for WarehousePage
 */
import { lazyRoute } from 'components/LazyRoute'

export default lazyRoute(() => import('./index'))
